import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { syncOracleEpmMetadata } from '../../../../slices/source';

export const useSyncMetadata = () => {
  const [syncLoading, setSyncLoading] = useState(false);
  const [syncResult, setSyncResult] = useState(null);
  const [availableDimensions, setAvailableDimensions] = useState([]);
  const dispatch = useDispatch();

  const handleSyncMetadata = async (hostname, username, password, version, applicationName, metadataExportName, createdSourceId) => {
    if (!hostname || !username || !password || !version || !applicationName || !metadataExportName) {
      setSyncResult({
        success: false,
        message: "Please fill in all required fields (hostname, username, password, version, application name, metadata export name)"
      });
      return;
    }

    setSyncLoading(true);
    setSyncResult(null);

    try {
      const formData = new FormData();
      formData.append('hostname', hostname);
      formData.append('username', username);
      formData.append('password', password);
      formData.append('version', version);
      formData.append('application_name', applicationName);
      formData.append('metadata_export_name', metadataExportName);
      
      // Include the created source_id if available
      if (createdSourceId) {
        formData.append('source_id', createdSourceId);
      }

      const result = await dispatch(syncOracleEpmMetadata(formData)).unwrap();
      setSyncResult(result);
      
      // Store available dimensions if sync is successful
      if (result.success && result.dimensions) {
        setAvailableDimensions(result.dimensions);
      } else {
        setAvailableDimensions([]);
      }
    } catch (error) {
      // Extract user-friendly error message
      let errorMessage = "Failed to create export metadata job";
      let errorDetail = "Unknown error occurred";
      
      // Handle different error structures
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        
        if (errorData.detail) {
          if (typeof errorData.detail === 'string') {
            errorDetail = errorData.detail;
          } else if (typeof errorData.detail === 'object' && errorData.detail.details) {
            errorDetail = errorData.detail.details;
          }
        }
        
        if (errorDetail && errorDetail !== "Unknown error occurred") {
          errorMessage = errorDetail;
          errorDetail = null;
        }
      } else if (error.payload) {
        const errorPayload = error.payload;
        if (errorPayload.detail) {
          if (typeof errorPayload.detail === 'string') {
            errorDetail = errorPayload.detail;
          } else if (typeof errorPayload.detail === 'object' && errorPayload.detail.details) {
            errorDetail = errorPayload.detail.details;
          }
        }
        
        if (errorDetail && errorDetail !== "Unknown error occurred") {
          errorMessage = errorDetail;
          errorDetail = null;
        }
      }
      
      setSyncResult({
        success: false,
        message: errorMessage,
        detail: errorDetail
      });
    } finally {
      setSyncLoading(false);
    }
  };

  const clearSyncResult = () => {
    setSyncResult(null);
  };

  return {
    syncLoading,
    syncResult,
    availableDimensions,
    setAvailableDimensions,
    handleSyncMetadata,
    clearSyncResult
  };
};

